module.exports = __webpack_public_path__ + "static/media/nibaoyijia.47cd59f4.png";